import FouGroup from 'components/layout/fou-group/'
import FouGrid from 'components/layout/fou-grid/'
import LoadAnimation from 'components/animations/loading'
import { mapGetters } from 'vuex'
export default {
  name: 'smartSorting',

  data () {
    return {
      smartSort: false
    }
  },

  props: {
    getSmartSortTrigger: {
      type: Function,
      default: () => {}
    },
    result: {
      type: Boolean
    }
  },

  components: {
    FouGroup,
    ...FouGrid,
    LoadAnimation
  },

  computed: {
    ...mapGetters('binaries', ['hasAllSortInfo'])
  },

  methods: {},

  created () {
    this.$events?.$on('unset_smart_sort', () => {
      this.smartSort = false
    })
  },

  watch: {
    smartSort: function (newV, oldV) {
      if (newV) {
        this.getSmartSortTrigger()
      }
    }
  },
  beforeUnmount () {
    this.$events.$off('unset_smart_sort')
  }
}
